export const environment = {
  baseUrl: 'https://api.phurshell.com/api/',
  s3_base_url: 'https://phurshell.s3-sa-east-1.amazonaws.com/',
  // pagarme_key: 'ek_live_tSzRSSpSvzjW62qUvhBoq7FvuNEbMx',
  pagarme_key: 'ek_test_6qyHIWuZYFX5OsRtPhDPeju1nAqXOZ',


  production: false
};
